<template>
  <b-overlay
    :show="loader"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <!-- search input -->
      <section id="knowledge-base-search">
        <b-button
          variant="primary"
          class="mb-2"
          @click="tourStart"
        >
          Indicaciones de primer Ingreso
        </b-button>
        <b-button
          variant="success"
          class="mb-2 ml-2"
          @click="$router.push('/alumno/documentos-relevantes')"
        >
          DOCUMENTOS RELEVANTES
        </b-button>
        <b-alert
          variant="primary"
          show
        >
          <h4 class="mb-2 alert-heading">
            <feather-icon
              class="mr-25"
              icon="StarIcon"
            /><span class="ml-25">Para disfrutar de nuestros servicios puedes seleccionar una de las opciones que vas a encontrar a continuación.</span>
          </h4>
        </b-alert>
      </section>
      <section id="knowledge-base-content">

        <!-- content -->
        <b-row class="kb-search-content-info match-height">
          <b-col
            id="'option-moodle"
            md="3"
            sm="6"
            class="kb-search-content"
          >
            <botonsalonclase />
          </b-col>
          <!-- list dinamic -->
          <b-col
            v-for="item in kbalumnos"
            :id="'option-'+item.id"
            :key="item.id"
            md="3"
            sm="6"
            class="kb-search-content"
          >
            <!-- tipoAlumno == 1 es un reprobado, se muestra el 7 solo si es reprobado -->
            <b-card
              v-if="item.id !== '7' || (tipoAlumno === 1 && item.id === '7')"
              :class="item.cls"
              :img-src="require('@/assets/images/illustration/' + item.img)"
              :img-alt="item.img.slice(5)"
              img-top
              @click="$router.push({ name: item.goahead })"
            >
              <h4>{{ item.title }}</h4>
              <b-card-text class="mt-1">
                {{ item.desc }}
              </b-card-text>
            </b-card>
          </b-col>
          <b-col
            v-show="!filteredKB.length"
            cols="12"
            class="text-center"
          >
            <h4 class="mt-4">
              Resultado de búsqueda no encontrado!!
            </h4>
          </b-col>
        </b-row>
        <app-tour :steps="stepsDashAlumno" />
      </section>
      <section id="knowledge-base-search">
        <b-alert
          variant="secondary"
          show
        >
          <h4 class="alert-heading">
            <feather-icon
              class="mr-25"
              icon="StarIcon"
            /><span class="ml-25">Mensaje de bienvenida
              <b-badge
                style="cursor: pointer;"
                variant="light-warning"
                @click="visualizarVideo = true"
              >
                Ver video
              </b-badge></span>
          </h4>
        </b-alert>
      </section>

      <section>
        <videodirector
          :vervideo.sync="visualizarVideo"
        />
        <!-- <avisotemporal /> -->
      </section>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BAlert, BButton, BOverlay, BBadge,
} from 'bootstrap-vue'
import store from '@/store'
import AppTour from '@core/components/app-tour/AppTour.vue'
import { getData } from '@core/utils/http/general'
import botonsalonclase from '@/views/campus/components/salondeclase/boton.vue'
import {
  onMounted, computed, ref, getCurrentInstance,
} from '@vue/composition-api'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import videodirector from './VideoBienvenida.vue'
// import avisotemporal from './AvisoTemporalEmergente.vue'
import { HelpVTour } from '../components/ayuda/useAyudaTour'

/* eslint-disable global-require */
export default {
  name: 'DashAlumno',
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BBadge,
    BButton,
    AppTour,
    BOverlay,
    botonsalonclase,
    videodirector,
    // avisotemporal,
  },
  setup() {
    const loader = ref(false)
    const tipoAlumno = ref(0)
    const kbalumnos = ref([])
    const knowledgeBaseSearchQuery = ref('')
    const vm = getCurrentInstance().proxy
    const toast = useToast()
    const visualizarVideo = ref(false)

    const {
      stepsDashAlumno,
    } = HelpVTour()

    const getTipoAlumno = () => {
      getData({ action: 22, token: store.state.cuenta.session.token }, 'wsalumno')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) {
            tipoAlumno.value = response.data.data
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - No podemos conocer que tipo de alumno eres`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
          loader.value = false
        }).catch(err => {
          loader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error, No hay conexión',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    const getDatas = () => {
      loader.value = true
      getData({ action: 8, token: store.state.cuenta.session.token }, 'wsadminpagecampus')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) kbalumnos.value = response.data.data
          else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - Sección en construcción`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
          loader.value = false
        }).catch(err => {
          loader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error, No hay conexión',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    const tourStart = () => {
      vm.$tours.vuexyTour.start()
    }

    onMounted(() => {
      getTipoAlumno()
      getDatas()
    })
    const filteredKB = computed(() => {
      const knowledgeBaseSearchQueryLower = knowledgeBaseSearchQuery.value.toLowerCase()
      return kbalumnos.value.filter(item => item.title.toLowerCase().includes(knowledgeBaseSearchQueryLower) || item.desc.toLowerCase().includes(knowledgeBaseSearchQueryLower))
    })

    return {
      stepsDashAlumno,
      getDatas,
      tourStart,
      loader,
      tipoAlumno,
      kbalumnos,
      knowledgeBaseSearchQuery,
      filteredKB,
      visualizarVideo,
    }
  },
}
</script>
<style scoped>
.importanteItem {
  border: 1px solid #7367f0;
}
</style>
<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';
@import '@core/scss/vue/libs/tour.scss';
</style>
